import { render, staticRenderFns } from "./EditClientDialog.vue?vue&type=template&id=1794069e&scoped=true&"
import script from "./EditClientDialog.vue?vue&type=script&lang=js&"
export * from "./EditClientDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditClientDialog.vue?vue&type=style&index=0&id=1794069e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794069e",
  null
  
)

/* custom blocks */
import block0 from "./EditClientDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports